var React = require('react');

function IconCommentO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M945.4 66.1H81.1c-8.9 0-16 7.1-16 16.1L64.6 959 255 767.6h690.5c8.8 0 16-7.2 16-16V82.1c-.1-8.9-7.3-16-16.1-16zm-46.4 621c0 8.8-7.2 16-16 16H228.5l-99.4 101.4.4-658.8c0-9 7.2-16.1 16-16.1h737.3c8.8 0 16 7.2 16 16v541.5h.2z","key":0}),React.createElement("path",{"d":"M266 256h492.1c5.5 0 10 4.5 10 10v44.3c0 5.5-4.5 10-10 10H266c-5.5 0-10-4.5-10-10V266c0-5.5 4.5-10 10-10zM267 384h492.1c5.5 0 10 4.5 10 10v44.3c0 5.5-4.5 10-10 10H267c-5.5 0-10-4.5-10-10V394c0-5.5 4.5-10 10-10zM265 512h492.1c5.5 0 10 4.5 10 10v44.3c0 5.5-4.5 10-10 10H265c-5.5 0-10-4.5-10-10V522c0-5.5 4.5-10 10-10z","key":1})]);
}

IconCommentO.displayName = "IconCommentO";

IconCommentO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCommentO;

IconCommentO.default = IconCommentO;
